<template>
    <v-container fluid class="white elevation-4 pt-0">
        <main-app-bar :title="$router.currentRoute.meta.title">
            <template v-slot:buttons>
                <v-btn v-if="isApprovePermission" @click="showHrTaskPopup = true">+ HR tasks</v-btn>
            </template>
        </main-app-bar>
        <div>
            <v-row class="d-block grey lighten-4">
                <div class="pa-3">
                    <v-btn-toggle
                        v-model="roleId"
                        color="primary"
                        tile
                        group
                        mandatory
                    >
                        <template v-for="role in currentClinicRoles">
                            <v-btn class="ma-0 mr-3 px-5 py-4" :value="role.roleId" v-if="!role.isHidden" :key="role.roleId">
                                {{role.title}}
                            </v-btn>
                        </template>
                        <v-btn class="ma-0 mr-3 px-5 py-4" value="personal">
                            personal
                        </v-btn>
                    </v-btn-toggle>
                </div>
                <v-toolbar
                    flat
                    class="pa-0 transparent"
                >
                    <v-btn color="black lighten-2" text class="btn-filter pa-1" @click="filterOpened = !filterOpened">
                        Filters
                        <v-icon right>$filter</v-icon>
                    </v-btn>
                    <div class="ml-5">
                        <v-chip v-for="chip in filterChips" :key="chip.id"
                            close small
                            v-on:click:close="removeTag(chip)"
                            close-icon="mdi-close" color="primary" class="ma-1 lighten-1">
                            {{chip.title}}
                        </v-chip>
                    </div>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-expand-transition>
                    <v-card v-show="filterOpened" elevation="0" class="px-5 transparent" height="auto"
                        style=" width: 100%;" :disabled="isLoading">
                        <v-row>
                            <v-col xs-3 class="align-flex-start" v-for="(filters, index) in filterLayout" :key="index">
                                <v-flex class="d-flex mb-5 test"  v-for="filterItem in filters" :key="filterItem.title">
                                    <v-select
                                        multiple
                                        v-model="filterOptions[filterItem.data]"
                                        :items="metaData[filterItem.data]"
                                        item-text="value"
                                        item-value="id"
                                        :placeholder="'Select ' + filterItem.title.substr(0, filterItem.title.length - 1)"
                                        dense
                                        outlined
                                        :label="filterItem.title"
                                        lighten-1
                                        class="ml-2"
                                        v-if="!filterItem.autocomplete"
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <span
                                                v-if="index === 0"
                                                class="selection-text-style"
                                            >{{ filterItem.type === 'arr' ? item : item.value}}</span>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text caption"
                                            >(+{{ filterOptions[filterItem.data].length - 1 }} others)</span>
                                        </template>
                                    </v-select>
                                    <v-autocomplete
                                        v-else
                                        v-model="filterOptions[filterItem.data]"
                                        :items="metaData[filterItem.data]"
                                        item-text="value"
                                        item-value="id"
                                        multiple
                                        dense
                                        outlined
                                        :label="filterItem.title"
                                        lighten-1
                                        :search-input.sync="searchInputAutocomplete[filterItem.typeAutocomplete]"
                                        @change="changeOption(filterItem.typeAutocomplete)"
                                        class="ml-2"
                                        :class="filterItem.data === 'taskTemplates' && 'text-uppercase'"
                                        :placeholder="'Select ' + filterItem.title.substr(0, filterItem.title.length - 1)"
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <span v-if="index === 0" class="selection-text-style">{{ filterItem.type === 'arr' ? item : item.value}}</span>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text caption"
                                            >(+{{ filterOptions[filterItem.data].length - 1 }} others)</span>
                                        </template>
                                        <template v-slot:item="{ item, attrs, on }" v-if="filterItem.data === 'taskTemplates'">
                                            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                                <v-list-item-action>
                                                    <v-checkbox :input-value="active"></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <span class="text-uppercase">{{ item.value }}</span>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-autocomplete>
                                </v-flex>
                            </v-col>
                            <v-col xs-3 class="align-flex-start">
                                <div>
                                    <div class="mb-5">
                                        <v-menu
                                            v-model="dueDateFromDatepickerStatus"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    :value="Date.formatDate([filterOptions.dueDateFrom])"
                                                    label="Due date from"
                                                    prepend-icon="mdi-calendar"
                                                    outlined
                                                    readonly
                                                    dense
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker first-day-of-week="1" v-model="filterOptions.dueDateFrom"
                                                @input="dueDateFromDatepickerStatus = false"></v-date-picker>
                                        </v-menu>
                                    </div>
                                    <div>
                                        <v-menu
                                            v-model="dueDateToDatepickerStatus"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            placeholer="from"
                                            offset-y
                                            max-width="290"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    :value="Date.formatDate([filterOptions.dueDateTo])"
                                                    label="Due date to"
                                                    prepend-icon="mdi-calendar"
                                                    outlined
                                                    dense
                                                    readonly
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker first-day-of-week="1" v-model="filterOptions.dueDateTo"
                                                @input="dueDateToDatepickerStatus = false"></v-date-picker>
                                        </v-menu>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-expand-transition>
            </v-row>
            <v-row v-if="!loadingFailed">
                <v-data-table
                    :loading="isLoading"
                    :headers="headers"
                    :items="tasks"
                    :options.sync="options"
                    :items-per-page="10"
                    :server-items-length="totalItems"
                    no-data-text="No tasks"
                    class="elevation-0 d-block"
                    :footer-props="{
          'items-per-page-options': [5,10,15,20],
        }"
                >
                    <template v-slot:body="{ items }">
                        <tr :key="item.id" v-for="item of items" @click="openTaskHandler(item.id)">
                            <td>
                                {{ item.title.toUpperCase() }}
                            </td>
                            <td>
                                <app-due-date-circle :date="item.dueDate" :isOverDue="item.isOverdue"
                                    :interval="item.interval"></app-due-date-circle>
                            </td>
                            <td>
                                {{item.interval}}
                            </td>
                            <td>
                                {{item.category}}
                            </td>
                            <td v-if="isApprovePermission">
                                {{item.employeeOnboarding}}
                            </td>
                            <td>
                                {{item.surgery}}
                            </td>
                            <td>
                                <div v-if="item.isOverdue && item.status === 'Pending'" class="d-flex">
                                    <v-icon class="mr-1">$overdue</v-icon>
                                    Overdue
                                </div>
                                <div v-else class="d-flex">
                                    <v-icon class="mr-1">{{item.status | statusToIcon}}</v-icon>
                                    {{ item.status }}
                                </div>
                            </td>
                            <td>
                                {{item.designator === 'None' ? ' ' : item.designator}}
                            </td>
                            <td align="right">
                                <v-btn icon fab small primary="transparent" class="elevation-0">
                                    <v-icon medium>$more</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
                <v-pagination v-if="totalPages > 1" v-model="options.page" :length="totalPages"
                    :total-visible="paginationTotalVisible"></v-pagination>
            </v-row>
            <div v-else>
                <h3 class="text-center mt-2">No data available</h3>
            </div>
        </div>
        <employee-task-view :isOpen="isTaskModalOpen" :taskId="taskId"
            :closeTaskViewModal="closeTaskViewModal"></employee-task-view>
        <hr-task-form-popup
            :isOpen="showHrTaskPopup"
            @closeModal="closeHrTaskPopup"
        ></hr-task-form-popup>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import AppDueDateCircle from '@/components/AppDueDateCircle'
    import MainAppBar from '@/components/MainAppBar'
    import { LEVELS } from '@/common/constants'
    import config from '@/common/config'
    import selectInputAutocomplete from '../../constatns/selectInputAutocomplete'

    const today = new Date()
    const defaultFilterOptions = {
        intervals: [],
        statuses: ['Pending'],
        categories: [],
        surgeries: [],
        superviseFlags: [],
        taskTemplates: [],
        dueDateFrom: '',
        dueDateTo: '',
        completedFrom: '',
        completedTo: '',
        employeesOnboarding: [],
        designators: []
        // IsShowOnlyLastTask: { // don`t remove
        //   value: false,
        //   title: 'Only the last copy of the task',
        //   getTitle: function () {
        //       return this.title
        //   }
        // }
    }
    const defaultValues = {
        // IsShowOnlyLastTask: { // don`t remove
        //   value: true,
        //   title: 'Most recent tasks',
        //   getTitle: function () {
        //     return this.title
        //   }
        // },
        dueDateFrom: today.toISOString().substr(0, 10),
        dueDateTo: new Date(today.getFullYear() + 1, today.getMonth() + 1).toISOString().substr(0, 10)
    }
    export default {
        data: () => ({
            activeCheckbox: false,
            roleId: null,
            loadingFailed: false,
            filterOptions: {
                ...defaultFilterOptions,
                ...defaultValues
            },
            dueDateFromDatepickerStatus: false,
            dueDateToDatepickerStatus: false,
            completedFromDatepickerStatus: false,
            completedToDatepickerStatus: false,
            totalItems: 1,
            paginationTotalVisible: config.paginationTotalVisible,
            options: {
                page: 1,
                itemsPerPage: 20,
                sortBy: ['dueDate'],
                sortDesc: [false],
                // groupBy: Array(0)
                // groupDesc: Array(0)
                mustSort: false,
                multiSort: false
            },
            filterOpened: false,
            metaData: {},
            isLoading: true,
            filteringTimerId: null,
            isTaskModalOpen: false,
            taskId: null,
            showHrTaskPopup: false,
            searchInputAutocomplete: {
                [selectInputAutocomplete.employee]: null,
                [selectInputAutocomplete.taskTemplate]: null,
                [selectInputAutocomplete.subUnits]: null
            }
        }),
        computed: {
            ...mapGetters({
                tasks: 'getEmployeeTasks',
                userActiveClinic: 'getUserActiveClinic',
                currentClinicRoles: 'getUserClinicRoles'
            }),
            headers () {
                const headersValues = [
                    {
                        text: 'Task',
                        align: 'left',
                        sortable: true,
                        value: 'title'
                    },
                    {
                        text: 'Due Date',
                        align: 'left',
                        sortable: true,
                        value: 'dueDate'
                    },
                    {
                        text: 'Interval',
                        align: 'left',
                        sortable: true,
                        value: 'interval'
                    },
                    {
                        text: 'Category',
                        align: 'left',
                        sortable: true,
                        value: 'category'
                    },
                    {
                        text: 'Sub-unit',
                        align: 'left',
                        sortable: true,
                        value: 'surgery'
                    },
                    {
                        text: 'Status',
                        align: 'left',
                        sortable: true,
                        value: 'status'
                    },
                    {
                        text: 'AM/PM',
                        align: 'left',
                        sortable: false,
                        value: ''
                    },
                    {
                        text: '',
                        align: 'left',
                        sortable: false,
                        value: ''
                    }
                ]
                if (this.isApprovePermission) {
                    headersValues.splice(4, 0, {
                        text: 'Employee (Starters/Leavers)',
                        align: 'left',
                        sortable: true,
                        value: 'employeesOnboarding'
                    })
                }
                return headersValues
            },
            isApprovePermission () {
                return this.$store.getters.getAllUserPermissions.includes(162)
            },
            filterChips () {
                const filterTags = []
                for (const key in this.filterOptions) {
                    const optionValue = this.filterOptions[key]
                    if (Array.isArray(optionValue)) {
                        optionValue.forEach(opt => {
                            const tag = {
                                id: this.$uuid.v1(),
                                key
                            }
                            if (isFilterItemObj(key)) {
                                const tagInfo = this.metaData[key].find(metaItem => metaItem.id === opt)
                                tag.title = key === 'taskTemplates' ? tagInfo.value.toUpperCase() : tagInfo.value
                                tag.value = tagInfo.id
                            } else if (isFilterItemBoolean(key)) {
                                let filterText = key
                                if (filterText === 'superviseFlags') {
                                    filterText = 'Watch'
                                }
                                if (opt) {
                                    tag.title = filterText.toUpperCase() + ' - true'
                                } else {
                                    tag.title = filterText.toUpperCase() + ' - false'
                                }
                                tag.value = opt
                            } else {
                                tag.title = opt
                                tag.value = opt
                            }
                            filterTags.push(tag)
                        })
                    } else {
                        const tag = {
                            id: this.$uuid.v1(),
                            key
                        }
                        if (isFilterItemDate(key)) {
                            tag.title = key.toUpperCase() + ' - ' + Date.formatDate([optionValue])
                            tag.value = optionValue
                            if (optionValue) {
                                filterTags.push(tag)
                            }
                        } else {
                            if (optionValue.value) {
                                tag.title = optionValue.getTitle()
                                tag.value = optionValue.value
                                filterTags.push(tag)
                            }
                        }
                    }
                }
                return filterTags
                function isFilterItemObj (key) {
                    return ['intervals', 'categories', 'surgeries', 'taskTemplates', 'employeesOnboarding'].indexOf(key) !== -1
                }
                function isFilterItemBoolean (key) {
                    return ['tempFlags', 'superviseFlags'].indexOf(key) !== -1
                }
                function isFilterItemDate (key) {
                    return ['dueDateFrom', 'dueDateTo', 'completedFrom', 'completedTo'].indexOf(key) !== -1
                }
            },
            totalPages: function () {
                return Math.ceil(this.totalItems / this.options.itemsPerPage)
            },
            isCurrentClinicRoles () {
                return true
                // return this.currentClinicRoles.length
            },
            filterLayout () {
                const filterLayout = [
                    [
                        {
                            title: 'Statuses:',
                            data: 'statuses',
                            model: 'statuses',
                            type: 'arr'
                        },
                        {
                            title: 'AM / PM:',
                            data: 'designators',
                            model: 'designators',
                            type: 'arr'
                        }
                    ],
                    [
                        {
                            title: 'Task templates:',
                            data: 'taskTemplates',
                            model: 'taskTemplates',
                            type: 'obj',
                            autocomplete: true,
                            typeAutocomplete: selectInputAutocomplete.taskTemplate
                        },
                        {
                            title: 'Sub-unit:',
                            data: 'surgeries',
                            model: 'surgeries',
                            type: 'obj',
                            autocomplete: true,
                            typeAutocomplete: selectInputAutocomplete.subUnits
                        }
                    ]
                ]
                if (this.isApprovePermission) {
                    filterLayout[0].push({
                        title: 'Employee (Starters/Leavers):',
                        data: 'employeesOnboarding',
                        model: 'employeesOnboarding',
                        type: 'obj',
                        autocomplete: true,
                        typeAutocomplete: selectInputAutocomplete.employee
                    })
                }
                return filterLayout
            }
        },
        watch: {
            roleId (val) {
                this.getEmployeeTasksDebounce()
            },
            currentClinicRoles () {
                if (this.currentClinicRoles[0]) {
                    this.roleId = this.currentClinicRoles[0].roleId ? this.currentClinicRoles[0].roleId : null
                }
                this.options.page = 1
                this.getEmployeeTasksDebounce()
            },
            filterOptions: {
                handler () {
                    this.options.page = 1
                    this.getEmployeeTasksDebounce()
                },
                deep: true
            },
            options: {
                handler () {
                    this.getEmployeeTasksDebounce()
                },
                deep: true
            }
        },
        methods: {
            async getEmployeeTasks () {
                const filterOptions = {}
                for (const optionName in this.filterOptions) {
                    if (!Object.prototype.hasOwnProperty.call(this.filterOptions, optionName)) {
                        continue
                    }
                    const filterOptionVal = this.filterOptions[optionName]
                    if (typeof filterOptionVal === 'object' && !Array.isArray(filterOptionVal)) {
                        filterOptions[optionName] = filterOptionVal.value
                    } else {
                        filterOptions[optionName] = filterOptionVal
                    }
                }
                const params = {
                    ...this.options,
                    clinicId: this.userActiveClinic,
                    filterOptions: {
                        ...filterOptions,
                        sortField: this.options.sortBy[0] || 'id',
                        sortOrder: this.options.sortDesc[0] ? 'DESC' : 'ASC'
                    }
                }
                const levelType = this.roleId === 'personal' ? 'personal' : 'clinic'
                // if (this.roleId === 'personal') {
                //   params.roles = this.currentClinicRoles.map(role => role.roleId)
                // } else {
                //   params.roles = this.roleId
                // }
                if (this.roleId !== 'personal') {
                    params.roles = this.roleId
                }
                params.levels = LEVELS.reduce((acc, level) => {
                    if (level.type === levelType) {
                        acc.push(level.value)
                    }
                    return acc
                }, [])
                if (this.userActiveClinic && this.roleId) {
                    this.isLoading = true
                    try {
                        this.metaData = await this.$store.dispatch('fetchEmployeeTasks', params)
                        this.loadingFailed = false
                    } catch (e) {
                        this.metaData = {}
                        this.loadingFailed = true
                    }
                    if (this.metaData) {
                        this.totalItems = this.metaData.totalElements
                    }
                    this.isLoading = false
                }
            },
            getEmployeeTasksDebounce () {
                clearTimeout(this.filteringTimerId)
                this.filteringTimerId = setTimeout(this.getEmployeeTasks, 200)
            },
            removeTag (chip) {
                if (chip.key) {
                    const filterOption = this.filterOptions[chip.key]
                    if (Array.isArray(filterOption)) {
                        this.filterOptions[chip.key] = filterOption.filter(option => chip.value !== option)
                    } else {
                        this.filterOptions[chip.key] = defaultFilterOptions[chip.key]
                    }
                }
            },
            openTaskHandler (id) {
                this.taskId = id
                this.isTaskModalOpen = true
            },
            closeTaskViewModal () {
                this.getEmployeeTasksDebounce()
                this.isTaskModalOpen = false
            },
            closeHrTaskPopup () {
                this.showHrTaskPopup = false
                this.getEmployeeTasksDebounce()
            },
            changeOption (typeSearch) {
                this.searchInputAutocomplete[typeSearch] = ''
            }
        },
        filters: {
            statusToIcon (val) {
                let icon = ''
                switch (val.toLowerCase()) {
                    case 'pending':
                        icon = '$timeFill'
                        break
                    case 'done':
                        icon = '$checkCircle'
                        break
                    case 'canceled':
                        icon = 'mdi-cancel'
                        break
                }
                return icon
            },
            dateFilter (dateIsoStr) {
                return dateIsoStr.substr(0, 10)
            }
        },
        async mounted () {
            await this.$store.dispatch('fetchRoles')
            this.isLoading = false
            if (this.currentClinicRoles[0]) {
                this.roleId = this.currentClinicRoles[0].roleId ? this.currentClinicRoles[0].roleId : 'personal'
            }
        },
        components: {
            AppDueDateCircle,
            MainAppBar,
            EmployeeTaskView: () => import('./TaskView'),
            hrTaskFormPopup: () => import('./components/hrTaskForm.vue')
        }
    }
</script>

<style scoped lang="scss">
    .v-data-table::v-deep {
        width: 100%;

        th {
            &:first-child{
                min-width: 250px;
            }
            min-width: 130px;
        }
    }

    .select-item-custom {
        width: 100%;
    }

    .btn-filter {
        svg {
            fill: #000
        }
    }
    .selection-text-style {
        font-size: 13px;
    }
    .expand-transition-enter-active, .expand-transition-leave-active {
        transition: .3s cubic-bezier(.25,.8,.5,1);
    }

</style>
